var map = {
	"./en-US/base.json": [
		"Lj+7",
		11
	],
	"./fil-PH/base.json": [
		"hrws",
		10
	],
	"./hi-IN/base.json": [
		"z1AZ",
		9
	],
	"./id-ID/base.json": [
		"rZnj",
		8
	],
	"./ms-MY/base.json": [
		"gK2X",
		7
	],
	"./th-TH/base.json": [
		"JeCA",
		6
	],
	"./vi-VN/base.json": [
		"tqsn",
		5
	],
	"./zh-CN/base.json": [
		"Z5EC",
		4
	],
	"./zh-TW/base.json": [
		"C6/T",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "UzpC";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*\/base\.json$
// module id = UzpC
// module chunks = 12